// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"selectBoundsMap_wrapper__3z9-P","map-wrapper":"selectBoundsMap_map-wrapper__3hZsA","leaflet-container":"selectBoundsMap_leaflet-container__3jpmR"};